import React from "react";
import Nav from "../components/Nav";

function Contact() {
  return (
    <div>
      <Nav />
      <h1>Hello This Is The Contact Page</h1>
    </div>
  );
}

export default Contact;
